// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import ErrorIcon from '@material-ui/icons/Error'
import WarningIcon from '@material-ui/icons/Warning'

import './index.css'

let notificationIcon = {
  error: <ErrorIcon />,
  warning: <WarningIcon />,
  success: <CheckCircleOutlineIcon />,
}

export default class FlashMessage extends Component {
  render () {
    const {message, type} = this.props
    if (message) {
      return (
        <div className='flash-message'>
          <div className={`container-fluid alert ${type}`}>
            {notificationIcon[type]}
            <span className='message'>&nbsp;{message}</span>
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}
